export enum PaymentTermType {
    Immediate = 'immediate', // PIA/CIA
    Net = 'net', // NET
}
